import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { UpdateContactTypeComponent } from './update-contact-type/update-contact-type.component'
import { CreateContactTypeComponent } from './create-contact-type/create-contact-type.component'
import { ContactTypesComponent } from './contact-types.component'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const contactTypesRoutes: Routes = [
  {
    path: 'admin/contact-types',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_MANAGEMENT_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: ContactTypesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateContactTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateContactTypeComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
